import { NodeUtils } from '@ssml-editor/vue';
import { SOUND_EVENT_TYPE } from './constant.js';

const soundEventPlugin = (editor) => {
  const { isInline, isVoid } = editor;
  const newEditor = editor;
  newEditor.isInline = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === SOUND_EVENT_TYPE) return true;
    return isInline(element);
  };
  newEditor.isVoid = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === SOUND_EVENT_TYPE) return true;
    return isVoid(element);
  };
  return newEditor;
};

export { soundEventPlugin };
//# sourceMappingURL=plugin.js.map
